import React, { useEffect } from 'react';
import './css/App.css';
import { useDispatch } from 'react-redux';
import { setInterval, getAllPlans } from './store/PlannedItemStore';
import Menu from './components/Menu';
import CustomTeamList from './components/organization/CustomTeamList';
import moment from 'moment';
import LorryNews from './components/slides/LorryNews';
import FreeText from './components/freeText/FreeText';
import SlideShow from './components/slides/SlideShow';

const Home = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const startOfDay = moment().startOf('day').valueOf();
        const endOfDay = moment().add(5, 'days').startOf('day').valueOf();

        dispatch(setInterval({start: startOfDay, end: endOfDay}));
        dispatch(getAllPlans());

        const updateDates = setInterval(() => {
            const newStartOfDay = moment().startOf('day').valueOf();
            const newEndOfDay = moment().add(5, 'days').startOf('day').valueOf();
            
            dispatch(setInterval({start: newStartOfDay, end: newEndOfDay}));
        }, 1000 * 180);

        return () => {
            clearInterval(updateDates);
        };
    }, [dispatch]);
    
    return (
        <div className="App">
            <Menu/>
            <CustomTeamList/>
            <div className='bottom-wrapper'>
                <div className='free-text-wrapper'>
                </div>

                <div className='slide-and-news-wrapper'>
                    <div className='news-slide'>
                        <LorryNews/>
                    </div>
                    <div className='slide-wrapper slide-show'>
                        <SlideShow slideShowId={10033} />
                    </div>
                    <FreeText/>                   
                </div>

            </div>
            
            
        </div>
    );
}

export default Home;